/**
 * Scroll the nearest scroll container (e.g. modal body) to the first field with an error.
 *
 * @param {ParentNode | null | undefined} scrollRoot
 * @param {Array<{ hasError: boolean, selector: string }>} fields ordered top-to-bottom
 */
export function scrollToFirstFormError(scrollRoot, fields) {
  const root = scrollRoot ?? document;
  for (const { hasError, selector } of fields) {
    if (!hasError) {
      continue;
    }
    const el = root.querySelector(selector);
    if (!el) {
      continue;
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const focusable = el.matches('input, textarea, select, button')
      ? el
      : el.querySelector('input, textarea, select, button');
    focusable?.focus({ preventScroll: true });
    return;
  }
}
